import {MaterialsNetworkSopNode} from './../../../../../@polygonjs/polygonjs/src/engine/nodes/sop/MaterialsNetwork';
import {GeoObjNode} from './../../../../../@polygonjs/polygonjs/src/engine/nodes/obj/Geo';
import {EventsNetworkSopNode} from './../../../../../@polygonjs/polygonjs/src/engine/nodes/sop/EventsNetwork';
import {PerspectiveCameraObjNode} from './../../../../../@polygonjs/polygonjs/src/engine/nodes/obj/PerspectiveCamera';
import {RootManagerNode} from './../../../../../@polygonjs/polygonjs/src/engine/nodes/manager/Root';
import {ExampleData, DataCallbackOptions} from '../../Common';

export function createData(options: DataCallbackOptions): ExampleData {
	const {scene} = options;
	const root = scene.root();

	function create_grid(parentNode: RootManagerNode) {
		var grid = parentNode.createNode('geo');
		grid.setName('grid');
		function create_planeHelper1(grid: GeoObjNode) {
			var planeHelper1 = grid.createNode('planeHelper');
			planeHelper1.setName('planeHelper1');
			planeHelper1.uiData.setPosition(0, 0);
			planeHelper1.flags.display.set(true);
			planeHelper1.params.postCreateSpareParams();
			planeHelper1.params.runOnSceneLoadHooks();
			return planeHelper1;
		}
		create_planeHelper1(grid);
		grid.uiData.setPosition(-50, -250);
		grid.flags.display.set(true);
		grid.params.postCreateSpareParams();
		grid.params.runOnSceneLoadHooks();
		return grid;
	}
	function create_hemisphereLight1(parentNode: RootManagerNode) {
		var hemisphereLight1 = parentNode.createNode('hemisphereLight');
		hemisphereLight1.setName('hemisphereLight1');
		hemisphereLight1.uiData.setPosition(150, 100);
		hemisphereLight1.flags.display.set(true);
		hemisphereLight1.params.postCreateSpareParams();
		hemisphereLight1.params.runOnSceneLoadHooks();
		return hemisphereLight1;
	}
	function create_perspectiveCamera1(parentNode: RootManagerNode) {
		var perspectiveCamera1 = parentNode.createNode('perspectiveCamera');
		perspectiveCamera1.setName('perspectiveCamera1');
		function create_events1(perspectiveCamera1: PerspectiveCameraObjNode) {
			var events1 = perspectiveCamera1.createNode('eventsNetwork');
			events1.setName('events1');
			function create_cameraOrbitControls1(events1: EventsNetworkSopNode) {
				var cameraOrbitControls1 = events1.createNode('cameraOrbitControls');
				cameraOrbitControls1.setName('cameraOrbitControls1');
				cameraOrbitControls1.uiData.setPosition(150, 50);
				cameraOrbitControls1.p.target.set([0.5899288964089694, 0.5957731355869416, -0.44842199957743734]);
				cameraOrbitControls1.params.postCreateSpareParams();
				cameraOrbitControls1.params.runOnSceneLoadHooks();
				return cameraOrbitControls1;
			}
			create_cameraOrbitControls1(events1);
			events1.uiData.setPosition(-200, 50);
			events1.params.postCreateSpareParams();
			events1.params.runOnSceneLoadHooks();
			return events1;
		}
		create_events1(perspectiveCamera1);
		perspectiveCamera1.uiData.setPosition(-200, 100);
		perspectiveCamera1.flags.display.set(true);
		perspectiveCamera1.p.t.set([2.577675363146063, 1.2667211759185875, 3.297697131252362]);
		perspectiveCamera1.p.r.set([-10.154286379496817, 27.578227989314495, 4.740021794010923]);
		perspectiveCamera1.p.s.set([1, 0.9999999999999999, 1]);
		perspectiveCamera1.p.controls.set('./events1/cameraOrbitControls1');
		perspectiveCamera1.params.postCreateSpareParams();
		perspectiveCamera1.params.runOnSceneLoadHooks();
		return perspectiveCamera1;
	}
	function create_sky(parentNode: RootManagerNode) {
		var sky = parentNode.createNode('geo');
		sky.setName('sky');
		function create_MAT(sky: GeoObjNode) {
			var MAT = sky.createNode('materialsNetwork');
			MAT.setName('MAT');
			function create_sky1(MAT: MaterialsNetworkSopNode) {
				var sky1 = MAT.createNode('sky');
				sky1.setName('sky1');
				sky1.uiData.setPosition(-50, 100);
				sky1.params.postCreateSpareParams();
				sky1.params.runOnSceneLoadHooks();
				return sky1;
			}
			create_sky1(MAT);
			MAT.uiData.setPosition(-350, 350);
			MAT.params.postCreateSpareParams();
			MAT.params.runOnSceneLoadHooks();
			return MAT;
		}
		function create_material1(sky: GeoObjNode) {
			var material1 = sky.createNode('material');
			material1.setName('material1');
			material1.uiData.setComment('here we assign the sky material to the sphere');
			material1.uiData.setPosition(-150, 350);
			material1.flags.display.set(true);
			material1.p.material.set('../MAT/sky1');
			material1.params.postCreateSpareParams();
			material1.params.runOnSceneLoadHooks();
			return material1;
		}
		function create_sphere1(sky: GeoObjNode) {
			var sphere1 = sky.createNode('sphere');
			sphere1.setName('sphere1');
			sphere1.uiData.setComment(
				'in order to have a sky that always appears to be far enough, we set the radius of the sphere to a large value, like 1000 in this case.\n\nThe material is set with depthWrite=false, so the far plane of the camera can remain closer than the radius.'
			);
			sphere1.uiData.setPosition(-150, -100);
			sphere1.p.radius.set(1000);
			sphere1.params.postCreateSpareParams();
			sphere1.params.runOnSceneLoadHooks();
			return sphere1;
		}
		create_MAT(sky);
		var material1 = create_material1(sky);
		var sphere1 = create_sphere1(sky);
		material1.setInput(0, sphere1);
		sky.uiData.setPosition(-50, -150);
		sky.flags.display.set(true);
		sky.params.postCreateSpareParams();
		sky.params.runOnSceneLoadHooks();
		return sky;
	}
	create_grid(root);
	create_hemisphereLight1(root);
	var perspectiveCamera1 = create_perspectiveCamera1(root);
	var sky = create_sky(root);
	return {
		scene,
		cameraPath: perspectiveCamera1.path(),
		focusedNodes: [sky.nodesByType('material')[0]],
		autoLayout: false,
	};
}
// export const matSky = [
// 	new Example({
// 		name: `${ExamplePrefix.BY_NODE}/mat/sky`,
// 		createData,
// 		relatedNodes: [SkyMatNode],
// 	}),
// ];
